import { Box, Hidden, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { useCounter } from "react-use";
import BrandCard from "./BrandCard";
import NextIcon from "./NextIcon";
import PrevIcon from "./PrevIcon";
import { ArrowButton, InnerList, OutsideList } from "./styles";
import { useViewportCardsCount } from "./utils";
import { BrandsListSectionFragment } from "./__generated__/BrandsListSectionFragment";
import deepEqual from "react-fast-compare";

type Props = BrandsListSectionFragment;

function BrandsListSection({ title, brands }: Props) {
  const theme = useTheme();

  const viewportCardsCount = useViewportCardsCount();

  const [cardIndex, { set: setCardIndex }] = useCounter(
    0,
    brands.length - viewportCardsCount
  );

  const nextPage = () => {
    setCardIndex(cardIndex + viewportCardsCount);
  };

  const prevPage = () => {
    setCardIndex(Math.max(cardIndex - viewportCardsCount, 0));
  };

  return (
    <Box>
      {/* List header */}
      <Box
        mb={{ xs: 2, md: 4 }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5">{title}</Typography>

        <Box display="flex" alignItems="center">
          {brands.length > viewportCardsCount && (
            <Hidden xsDown implementation="css">
              <ArrowButton
                disabled={cardIndex === 0}
                style={{ marginLeft: theme.spacing(2) }}
                onClick={() => prevPage()}
              >
                <PrevIcon />
              </ArrowButton>

              <ArrowButton
                disabled={cardIndex >= brands.length - viewportCardsCount}
                style={{ marginLeft: theme.spacing(0.5) }}
                onClick={() => nextPage()}
              >
                <NextIcon />
              </ArrowButton>
            </Hidden>
          )}
        </Box>
      </Box>

      {/* List products */}
      <OutsideList>
        <InnerList
          animate={{
            x: `-${(100 / brands.length) * cardIndex}%`
          }}
          transition={{
            type: "spring",
            damping: 22,
            stiffness: 200,
            duration: 0.5
          }}
        >
          {brands.map(brandCard => (
            <BrandCard key={brandCard.brand.slug} {...brandCard} />
          ))}
        </InnerList>
      </OutsideList>
    </Box>
  );
}

export default React.memo(BrandsListSection, deepEqual);
